import React from "react";
import "./utilis.css";

const AdminNavBar = () => {
  return <div className="AdminNavbar ">AdminNavBar</div>;
};

export default AdminNavBar;
